import React from 'react';
import { Dialog, Typography, DialogTitle, DialogContent, Link, Alert } from '@mui/material';

import type { IntakeStatusBaseSteps } from '@shared/patient-intake-status';

import { MHRAccessViewer } from '../../../components';
import { usePatientIntakeStatusContext } from '../../../hooks';

type ViewMHRCompletionModalProps = {
  step: IntakeStatusBaseSteps['MHR_ACCESS'];
  isOpen: boolean;
  onClose: () => void;
};

const PatientSection = () => {
  const { isHealthcareProvider } = usePatientIntakeStatusContext();

  if (isHealthcareProvider) {
    return null;
  }

  return (
    <Alert severity="info" icon={false}>
      If you would like to update your access code, please contact support. More information about your{' '}
      <strong>My Health Record</strong> account can be found{' '}
      <Link
        href="https://www.digitalhealth.gov.au/initiatives-and-programs/my-health-record/getting-started/how-to-access-my-health-record"
        target="_blank"
        rel="noopener noreferrer"
      >
        here
      </Link>
      .
    </Alert>
  );
};

export const ViewMHRCompletionModal: React.FC<ViewMHRCompletionModalProps> = ({ step, isOpen, onClose }) => (
  <Dialog open={isOpen} onClose={onClose}>
    <DialogTitle>
      <Typography variant="h6">My Health Record Access Code</Typography>
    </DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <MHRAccessViewer step={step} />

      <PatientSection />
    </DialogContent>
  </Dialog>
);
